import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import { type ContactTypeFlags, contactTypes } from '../contactTypes'
import { contactTypeBadge, contactTypeBadges } from './ContactTypeBadges.css'

type Props = {
  contact: Partial<ContactTypeFlags>
}

export const ContactTypeBadges = ({ contact }: Props): ReactElement | null => {
  const heldTypes = contactTypes.filter(({ key }) => contact[key] === true)

  if (heldTypes.length === 0) {
    return null
  }

  return (
    <span className={contactTypeBadges}>
      {heldTypes.map(({ key, label, icon }) => (
        <span key={key} className={contactTypeBadge}>
          <FontAwesomeIcon icon={icon} />
          {label}
        </span>
      ))}
    </span>
  )
}
